import { ValidationRuleFunction } from 'vee-validate/dist/types/types';

// 半角英数字「_」「-」のみ使用できます(記号のみは不可)
const original_path: ValidationRuleFunction = (value = '') => {
  return (
    value.match(/^[a-zA-Z0-9\-_]*[a-zA-Z0-9]{1,}[a-zA-Z0-9\-_]*$/) !== null
  );
};

export default original_path;
